var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:outline-payments"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.8333 11.6663V4.99967C15.8333 4.08301 15.0833 3.33301 14.1666 3.33301H2.49992C1.58325 3.33301 0.833252 4.08301 0.833252 4.99967V11.6663C0.833252 12.583 1.58325 13.333 2.49992 13.333H14.1666C15.0833 13.333 15.8333 12.583 15.8333 11.6663ZM14.1666 11.6663H2.49992V4.99967H14.1666V11.6663ZM8.33325 5.83301C6.94992 5.83301 5.83325 6.94967 5.83325 8.33301C5.83325 9.71634 6.94992 10.833 8.33325 10.833C9.71659 10.833 10.8333 9.71634 10.8333 8.33301C10.8333 6.94967 9.71659 5.83301 8.33325 5.83301ZM19.1666 5.83301V14.9997C19.1666 15.9163 18.4166 16.6663 17.4999 16.6663H3.33325V14.9997H17.4999V5.83301H19.1666Z",
    fill: "white",
    fillOpacity: 0.9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayments);
export default __webpack_public_path__ + "static/media/payments.ba316f96a98dd06d0715292b6e48e303.svg";
export { ForwardRef as ReactComponent };